"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OtpCodeToJSON = exports.OtpCodeFromJSONTyped = exports.OtpCodeFromJSON = void 0;
function OtpCodeFromJSON(json) {
    return OtpCodeFromJSONTyped(json, false);
}
exports.OtpCodeFromJSON = OtpCodeFromJSON;
function OtpCodeFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'otpSessionId': json['otpSessionId'],
        'otpCode': json['otpCode'],
    };
}
exports.OtpCodeFromJSONTyped = OtpCodeFromJSONTyped;
function OtpCodeToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'otpSessionId': value.otpSessionId,
        'otpCode': value.otpCode,
    };
}
exports.OtpCodeToJSON = OtpCodeToJSON;
//# sourceMappingURL=OtpCode.js.map